"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "list-romaneio-table table-items-list"
  }, [_c("b-table", {
    attrs: {
      data: _vm.data,
      loading: _vm.isLoading,
      striped: true,
      hoverable: true,
      "mobile-cards": true
    },
    on: {
      "update:loading": function updateLoading($event) {
        _vm.isLoading = $event;
      }
    }
  }, [_c("b-table-column", {
    attrs: {
      field: "register",
      label: "Nº ROMANEIO"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n      " + _vm._s(props.row.register) + "\n    ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "harvestDate",
      label: "D. COLHEITA"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n      " + _vm._s(_vm.formatDate(props.row.harvestDate)) + "\n    ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "plate",
      label: "VEÍCULO"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n      " + _vm._s(props.row.plate) + "\n    ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "pallets",
      label: "PALLETS"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n      " + _vm._s(props.row.pallets) + "\n    ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "clientName",
      label: "CLIENTE"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        var _props$row$clientData;
        return [_vm._v("\n      " + _vm._s((_props$row$clientData = props.row.clientData) === null || _props$row$clientData === void 0 ? void 0 : _props$row$clientData.name) + "\n    ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "plotName",
      label: "ÁREA"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        var _props$row$plotData;
        return [_vm._v("\n      " + _vm._s((_props$row$plotData = props.row.plotData) === null || _props$row$plotData === void 0 ? void 0 : _props$row$plotData.name) + "\n    ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "subplotName",
      label: "SUB-ÁREA"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        var _props$row$subPlotDat;
        return [_vm._v("\n      " + _vm._s((_props$row$subPlotDat = props.row.subPlotData) === null || _props$row$subPlotDat === void 0 ? void 0 : _props$row$subPlotDat.nickname) + "\n    ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      label: "Ações",
      centered: ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_c("div", {
          staticClass: "col-actions"
        }, [_c("b-button", {
          on: {
            click: function click($event) {
              return _vm.openModalRomaneioDetails(props.row);
            }
          }
        }, [_c("i", {
          staticClass: "icon-ic_info"
        })]), _vm._v(" "), _c("b-button", {
          on: {
            click: function click($event) {
              return _vm.printReport(props.row);
            }
          }
        }, [_c("i", {
          staticClass: "icon-ic_print"
        })])], 1), _vm._v(" "), _c("div", {
          staticClass: "col-actions"
        }, [_c("b-button", {
          staticClass: "btn-delete",
          on: {
            click: function click($event) {
              return _vm.openModalEdit(props.row);
            }
          }
        }, [_c("i", {
          staticClass: "icon-ic_edit"
        })]), _vm._v(" "), _c("b-button", {
          staticClass: "btn-delete",
          on: {
            click: function click($event) {
              return _vm.verifyDelete(props.row);
            }
          }
        }, [_c("i", {
          staticClass: "icon-delete"
        })])], 1)];
      }
    }])
  })], 1)], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;